import { Component, OnInit } from '@angular/core';
import { BaseActComponent } from 'app/_controls/base-act.component';

// RxJs
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { GeoType } from 'app/_core/predefined/enums';
import { CareGiverFilter, Language, PageInfo, CareGiver, ListOfValues, Facility, FacilityFilter } from 'app/_core/models';
import { GlobalService } from 'app/_core/api-access/global.service';
import { CareGiverService } from 'app/_core/api-access/caregiver.service';
import { MediaService } from 'app/_core/api-access/media.service';
import { FacilityService } from 'app/_core/api-access/facility.service';
@Component({
  selector: 'app-caregiver-list-extend',
  templateUrl: './caregiver-list-extend.component.html'
})

export class CareGiverListExtendComponent extends BaseActComponent implements OnInit {

  public readonly facilities$: Observable<Facility[]>;
  public readonly careGivers$: Observable<CareGiver[]>;
  public readonly pageInfo$: Observable<PageInfo>;
  public readonly geoType = GeoType;

  // Keep form value
  public careGiverFilter: CareGiverFilter = new CareGiverFilter();
  public facilityFilter: FacilityFilter = new FacilityFilter();

  // Pagination
  public pageOffset: number;
  public pageLimit: number;
  public pageNumberSelected: number;

  public globalData: ListOfValues;

  public readonly facilityLoadOffset: number = 0;
  public readonly facilityLoadLimit: number = 6;

  constructor(
    private careGiverService: CareGiverService,
    private route: ActivatedRoute,
    private router: Router,
    private facilityService: FacilityService,
    private globalService: GlobalService,
    private mediaService: MediaService,) {
    super();

    // Subscribe to entire collection
    this.careGivers$ = this.careGiverService.careGiversObs;
    // Page info
    this.pageInfo$ = this.careGiverService.pageInfoObs;

    this.facilities$ = this.facilityService.facilitiesObs;
  }

  loadGlobal() {
    if (this.globalService.getCacheGlobal())
      this.globalData = this.globalService.getCacheGlobal();
    else
      this.globalService.getGlobal().pipe(first()).subscribe(global => {
        this.globalData = global;
        this.globalService.setCacheGlobal(global);
      });
  }

  ngOnInit(): void {
    this.loadGlobal();
    // Process
    this.route.queryParamMap.subscribe(params => {
      this.careGiverFilter.Name = params.get('name');

      // Get filter values from params
      this.careGiverFilter.GeoId = +params.get('geo_id');
      this.careGiverFilter.GeoType = params.get('geo_type');
      this.careGiverFilter.GeoName = params.get('geo_name');

      // TODO: should get it from api, get detail for geotype and id above, or return on result together.
      this.careGiverFilter.GeoCityId = +params.get("geo_city_id");
      this.careGiverFilter.GeoCityName = params.get("geo_city_name");
      this.careGiverFilter.GeoCountyId = +params.get("geo_county_id");
      this.careGiverFilter.GeoCountyName = params.get("geo_county_name");
      this.careGiverFilter.GeoStateId = +params.get("geo_state_id");
      this.careGiverFilter.GeoStateName = params.get("geo_state_name");

      // Other params
      this.careGiverFilter.Distmi = +params.get('distmi') || null;

      // Populate languages from ids
      const languageIdsText = params.get('language_ids');
      let languageIds: String[] = [];
      if (languageIdsText)
        languageIds = languageIdsText.split(',');

      let languages: Language[] = [];
      if (languageIds.length > 0)
        languages = languageIds.map(id => {
          const index = this.globalData.Languages.findIndex(l => l.Id === +id);
          if (index > -1)
            return this.globalData.Languages[index];
        });

      // Languages parameter
      this.careGiverFilter.Languages = languages;

      // Pagination
      const offset: number = +params.get("page_offset");
      this.pageOffset = offset ? offset : 0;

      const limit: number = +params.get("page_limit");
      this.pageLimit = limit ? limit : 12;

      // Load data
      this.careGiverService.load(this.pageOffset, this.pageLimit, this.careGiverFilter);
        
      // Load Facilities related
      this.facilityFilter.GeoType = this.geoType.County;
      this.facilityFilter.GeoId = 0;
      this.facilityService.load(this.facilityLoadOffset, this.facilityLoadLimit, this.facilityFilter);
    });
  }

  getImageUrl(guid: string) {
    return this.mediaService.getImageUrl(guid);
  }

  onPaginationChange(pageNumber: number, totalPage: number) {
    if (pageNumber < 1 || pageNumber > totalPage) {
      return;
    }

    this.pageNumberSelected = pageNumber;
    this.pageOffset = (pageNumber - 1) * this.pageLimit;

    // Load data with new page and current condition
    this.careGiverService.load(this.pageOffset, this.pageLimit, this.careGiverFilter);
  }

  redirectTo(uri: string, params: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      // Query params
      params ? this.router.navigate([uri], { queryParams: params }) : this.router.navigate([uri])
    );
  }

  getFilter(filter: CareGiverFilter) {
    if (!filter)
      return;

    // Reset pageOffset, and load with new conditions
    this.pageOffset = 0;
    this.careGiverService.load(this.pageOffset, this.pageLimit, filter);
  }
}
